var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-message alert alert-success",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('clearMessage')}}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }